import { render, staticRenderFns } from "./messageLog.vue?vue&type=template&id=bacb10d0&scoped=true"
import script from "./messageLog.vue?vue&type=script&lang=js"
export * from "./messageLog.vue?vue&type=script&lang=js"
import style0 from "./messageLog.vue?vue&type=style&index=0&id=bacb10d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacb10d0",
  null
  
)

export default component.exports